import { INITIAL_POSITION } from './AIAssistantDialog';

interface CalculateDraggableBoundariesParams {
  windowWidth: number;
  windowHeight: number;
  elementWidth: number;
  elementHeight: number;
}

export const calculateDraggableBoundaries = 
 ({ windowWidth, windowHeight, elementWidth, elementHeight }: CalculateDraggableBoundariesParams) =>
   ({ 
     left: -(windowWidth - elementWidth - INITIAL_POSITION.right),
     right: INITIAL_POSITION.right, 
     top:  -INITIAL_POSITION.top,
     bottom: (windowHeight - elementHeight - INITIAL_POSITION.top), 
   });
